export default __webpack_public_path__ + "files/RP2_Policy_Factsheet_1_Austrian_landfill_tax_and_Waste_Prevention_Programmes.docx";